import * as React from 'react';

function SvgHeartOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M17.048 3C13.667 3 12 6.333 12 6.333S10.333 3 6.952 3C4.205 3 2.03 5.299 2.001 8.042c-.058 5.694 4.516 9.743 9.53 13.146a.833.833 0 00.938 0c5.013-3.403 9.587-7.452 9.53-13.146C21.972 5.299 19.796 3 17.049 3v0z" })));
}

export default SvgHeartOutline;
